import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import Invoice from './downloadInvoice';
import Loader from '../../components/loader';
import newEWayBill from './eWayBill';

import { InvoiceDocument } from './invoiceTemplate';
import ReactDOM from 'react-dom/client';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

function App() {

    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
    const [whatsappNum, setWhatsAppNum] = useState(false);
    const [newWhatsappNum, setNewWhatsAppNum] = useState(0);
    const [selectedSections, setSelectedSections] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [distError, setDisterror] = useState(null);
    const [ewbError, setEWBError] = useState(null);
    const [einvError, setINVError] = useState(null);
    const [einvCanError, setINVCanError] = useState(null);

    const bottomRef = useRef(null);

    const scrollToBottom = () => {
        bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const [orderData, setOrderData] = useState('');
    const [orderId, setOrderId] = useState(null);
    const [address, setAddress] = useState([]);
    const [dispatchAddress, setDispatchAddress] = useState(null);
    const [cartItems, setCartItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst, setGST] = useState(0);
    const [gst2, setGST2] = useState(0);
    const [crates, setCrates] = useState(0);
    const [qty, setQty] = useState(0);
    const [weight, setWeight] = useState(0);
    const [edit, setEdit] = useState(false);
    const [inputData, setInputData] = useState('');
    const [newTotal, setNewTotal] = useState(0);
    const [newGst, setNewGst] = useState(0);
    const [newDiscount, setNewDiscount] = useState(0);
    const [scheme, setScheme] = useState(0);
    const [vNum, setVNum] = useState('');
    const [eNum, setENum] = useState('');
    const [discounts, setDiscounts] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [shipping, setShipping] = useState(null);
    const [shippingAddress, setShippingAddress] = useState(null);
    const [productData, setProductData] = useState([]);
    const [addSection, setAddSection] = useState(false);
    const [selectedProduct, setProduct] = useState('');
    const [newQty, setNewQty] = useState('');
    const [inputType, setinputType] = useState('crates');
    const [notes, setNotes] = useState('');
    const [newDiscounts, setNewDiscounts] = useState([]);

    const [discountValue, setDiscountValue] = useState(0);
    const [discountData, setDiscountData] = useState([]);

    const [newDiscountValue, setNewDiscountValue] = useState(0);
    const [newDiscountData, setNewDiscountData] = useState([]);
    const [ewbPop, setEwbPop] = useState(false);
    const [invCancelPop, setInvCancelPop] = useState(false);
    const [invCancelReason, setInvCancelReason] = useState('');
    const [invCancelStatus, setInvCancelStatus] = useState(null);
    const [ewbInputs, setEWBInputs] = useState([]);
    const [invEdit, setInvEdit] = useState(false);
    const [invEditReason, setInvEditReason] = useState('');
    const [invEditStatus, setInvEditStatus] = useState(null);
    const [recInc, setReccInc] = useState(0);
    const [incentive, setIncentive] = useState(0);
    const [incentiveMultiple, setIncentiveMultiple] = useState(0);
    const [incentiveData, setIncentiveData] = useState([]);
    const [curdWeight, setCurdWeight] = useState(0);
    const [milkWeight, setMilkWeight] = useState(0);
    const [totalIncentive, setTotalIncentive] = useState(0);

    useEffect(()=> {
        const totalWeight = curdWeight + milkWeight;
        const incentiveMulti =  Number(Number(orderData?.dealerData?.leakage) + 
                                Number(orderData?.dealerData?.cNf) + 
                                Number(orderData?.dealerData?.transPort) + 
                                Number(orderData?.dealerData?.margin) +
                                Number(orderData?.dealerData?.secInc));
        setIncentiveMultiple(incentiveMulti);
        const otherIncentives = incentiveMulti * totalWeight;
        const totalIncentive = Number(otherIncentives + Number(orderData?.incentive));
        setTotalIncentive(totalIncentive);

    },[curdWeight, milkWeight]);

    const getReccInc = () => {

        let basicIncetive = 0;
        let milkWeight = 0;
        let curdWeight = 0;

        incentiveData?.forEach(invoice => {

            const incetive = Number(invoice?.incentive);
            basicIncetive += incetive;

            invoice?.items?.forEach(item => {

                const weight = ((Number(item?.crates) * Number(item?.qty) * Number(item?.weight)) / 1000);

                if(item?.type === 'milk'){
                    milkWeight += weight;
                }

                if(item?.type === 'curd'){
                    curdWeight += weight;
                }
            });
        });

        const totalWeight = milkWeight + curdWeight;
        const otherIncentives = totalWeight * incentiveMultiple;
        const totalIncentive = Number(basicIncetive + otherIncentives).toFixed(2);
        setReccInc(totalIncentive);
    };

    useEffect(()=>{
        getIncetive();
    },[orderData]);

    useEffect(()=>{
        getReccInc();
    },[incentiveData]);

    const getDate = (date) => {
        const newDate = new Date(date);

        if (isNaN(newDate)) {
            return null;
        }

        const year = newDate.getFullYear();
        const month = newDate.getMonth() + 1;

        return [year, month];
    };

    const getIncetive = async () => {

        if(!orderData){
            return;
        }

        const [year, month] = getDate(orderData?.date);

        if(!year && !month){
            return;
        }

        setLoader(true);

            const headers = {
                'Content-Type': 'application/json',
                'X-API-KEY': 'erpTrucoo'
            };

            try {
                const orderAPI = await axios.post('https://api.trucoo.in/invoice/incentive/', {month: month, year: year, date:orderData?.date, dealer: orderData?.dealerId}, {headers});
                if (orderAPI.data.status === 'success') {
                    setIncentiveData(orderAPI?.data?.data);
                }
            } catch (error) {
                console.error("Error:", error.orderAPI || error.message);
            }
            setLoader(false);
            
    }; 


    const downloadPDF = async (invoice) => {
       
    
        // 1️⃣ Create a hidden wrapper
        const wrapper = document.createElement("div");
        wrapper.style.position = "absolute";
        wrapper.style.left = "-9999px";
        wrapper.style.top = "0";
        wrapper.style.background = "white";
        document.body.appendChild(wrapper);
    
        // 2️⃣ Render your full document into it
        const root = ReactDOM.createRoot(wrapper);
        root.render(<InvoiceDocument invoice={invoice} />);
    
        // 3️⃣ Wait for React to fully render DOM
        await new Promise((r) => setTimeout(r, 500));
    
        // 4️⃣ Identify page divs (each with className="page")
        const pages = wrapper.querySelectorAll(".page");
        const pdf = new jsPDF("p", "mm", "a4");
    
        for (let i = 0; i < pages.length; i++) {
          const page = pages[i];
          const canvas = await html2canvas(page, { scale: 2, useCORS: true });
          const imgData = canvas.toDataURL("image/jpeg", 1.0);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        }
    
        pdf.save(`Invoice-${invoice?.clientName}-${invoice?.invId}.pdf`);
    
        // 5️⃣ Cleanup
        root.unmount();
        wrapper.remove();
      };

    const sectionIds = [
        { id: 'printableArea1', label: 'ORIGINAL' },
        orderData?.eWayNum?.length > 0 && { id: 'printableArea2', label: 'E Way Bill' },
        { id: 'printableArea3', label: 'TRANSPORTER' },
        { id: 'printableArea4', label: 'OFFICE' },
    ].filter(Boolean);

    const handleCheckboxChange = (id) => {
        setSelectedSections((prevSelected) =>
            prevSelected.includes(id)
            ? prevSelected.filter((sectionId) => sectionId !== id) // Remove if already selected
            : [...prevSelected, id] // Add if not selected
        );
    };


    const handleDiscountTypeChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                return prevData.map(item =>
                    item.item === itemId ? { ...item, type: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: value, discount: '', value: 0, item: itemId }];
            }
        });
    };

    const handleDiscountValueChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                //console.log('Exist', itemId);
                return prevData.map(item =>
                    item.item === itemId ? { ...item, value: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: '', discount: '', value: value, item: itemId }];
            }
        });
    };

    const handleDiscountDiscountChange = (value, itemId) => {
        setNewDiscountData((prevData) => {
            const itemExists = prevData.some(item => item.item === itemId);

            if (itemExists) {
                // Update existing item
                return prevData.map(item =>
                    item.item === itemId ? { ...item, discount: value } : item
                );
            } else {
                // Add new item
                return [...prevData, { type: '', discount: value, value: 0, item: itemId }];
            }
        });
    };

    
    function getFiscalYearLabel(date = new Date()) {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };

    useEffect(() => {
        const orderid = getQueryParam('id');
        setOrderId(orderid);
    }, [userID]);

    useEffect(() => {
        scrollToBottom();
    }, [edit]);

    const getOrder = async () => {
        setLoader(true);
		try {
			const response = await axios.post('https://api.trucoo.in/invoice/order-details/', {orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			 //console.log(response.data);
			if(response?.data?.status === 'success'){
				setOrderData(response?.data?.data);
                setDiscountData(JSON.parse(response?.data?.data?.discountData || '[]'));
                setNewDiscountData(JSON.parse(response?.data?.data?.discountData || '[]'));
                setDispatchAddress(response.data.data?.dispatch?.id);
                setShippingAddress(response.data.data?.ships);
                setVNum(response.data.data?.vNum || '');
                setENum(response.data.data?.eWayNum || '');
                setNotes(response.data.data?.notes || '');
                setNewWhatsAppNum(response.data.data?.dealerData?.phone);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
        setLoader(false);
	};

    const getAddress = async () => {
		try {
			const response = await axios.get('https://api.trucoo.in/address/get/', {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				setAddress(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

    const getShipping = async (id) => {
		try {
			const response = await axios.post('https://api.trucoo.in/shipping/get/', {dealerId : id}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
				setShipping(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};

    const getProducts = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/products/all-product/', {userId: userID}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

			if(response.data.status === 'success'){
				setProductData(response.data.data);
				sessionStorage.setItem('cartItems', JSON.stringify([]));
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	useEffect(() => {
		getOrder();
        getAddress();
        getProducts();
	},[orderId]);

    const changeNewQty = (e) => {
		const qtys = e.target.value;
		setNewQty(qtys);
	};

	const changeNewQtyBtn = (calc) => {
		if(calc === 'plus'){
			if(newQty === '' || isNaN(newQty)){
				setNewQty(1);
			}else{
				setNewQty(parseFloat(newQty)+1);
			}
		}else{
			if(newQty === 0){
				setNewQty(newQty);
			}else{
				setNewQty(parseFloat(newQty)-1);
			}
		}
	};

    const addToExt = async () => {

        let productPrice = 0;

        if(selectedProduct === '' || newQty === '' || isNaN(newQty)){
            alert('Please select product and enter quantity');
            return;
        }
        const products = productData.find(item => item.id === selectedProduct);
        if(!products){
            alert('Product not found');
            return;
        }


        const rateData = {
            dealer: orderData?.dealerData?.id,
            product: selectedProduct
        };

        try{
            const response = await axios.post('https://api.trucoo.in/products/rate/', rateData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
            });

            if(response?.data?.status === 'success'){
                productPrice = parseFloat(response?.data?.data?.price);
            }
        }catch(error){
            console.error(error);
        }
        


        const oneCrate = (parseFloat(products.grade) * parseFloat(products.productWeight)) / 1000;

        let newQtys = 0;

        if(inputType === 'crates'){
            newQtys = parseFloat(newQty);
        }else{
            newQtys = parseFloat(newQty) / oneCrate;
        }

        const newItem = {
            discountType: '',
            discountValue: '',
            id: '',
            itemCode: products?.productCode,
            itemGrade: products?.grade,
            itemGst: products?.productGst,
            itemHsn: products?.productHsn,
            itemId: products?.id,
            itemName: products?.productName,
            itemPrice: productPrice,
            itemUnit: products?.unit,
            itemWeight: products?.productWeight,
            itemType: products?.type,
            orderId: orderId,
            subtotal: parseFloat(products?.productPrice * products?.grade * newQty),
            qty: newQtys,
        }

        //console.log(newItem);

        try {
			const response = await axios.post('https://api.trucoo.in/invoice/add-item/', newItem, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			
            //console.log(response.data);

			if(response.data.status === 'success'){
			    setAddSection(!addSection);
                setNewQty('');
                setProduct('');
                getOrder();
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}

        
    };

    const getDiscountCrates = (product) => {
     
        const productData = orderData?.orderData?.find(items => items.itemId === product);
        const discountData = newDiscountData?.find(items => items.item === product); 

        if (!productData || !discountData) {
            //console.warn("Product or discount not found");
            return 0; 
        } 
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.itemPrice);
        const crates = parseFloat(productData.itemGrade);
        const weight = parseFloat(productData.itemWeight);
        const gst = parseFloat(productData.itemGst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;
    
        if (isNaN(qty) || isNaN(productPrice) || isNaN(crates) || isNaN(weight)) {
            //console.warn("Invalid product data");
            return 0;
        }
    
        if (!discountData.value || isNaN(discountData.value)) {
            //console.warn("Invalid discount value");
            return 0;
        }

        if(discountData.discount === 'amount'){
            return 0;
        }
    
        if (discountData.type === 'grade') {
            if (discountData.discount === 'packet') {
                return (parseFloat(discountData.value) * qty) / crates;
            } else {
                return ((parseFloat(discountData.value) * qty) / productPrice) / crates;
            }
        }
    
        if (discountData.type === 'percent') {
            const total = qty * crates * productPrice;
            return total * (parseFloat(discountData.value) / 100);
        }
    
        if (discountData.type === 'liters') {
            if (discountData.discount === 'litre') {
                const ltrs = qty * crates * (weight/1000);
                const discLtr = ltrs * discountData.value;
                return (discLtr / crates);
            } else {
                const ltrs = qty * crates * (weight/1000);
                const ltrprice = ltrs * discountData.value;
                const ltrQty = ltrprice/productPrice;
                return (ltrQty / crates);
            }
        }

        if (discountData.type === 'packet') {
            const values = parseFloat(discountData.value);
            const disQty = qty * crates;
            return (disQty * values) / crates;
        }
    
        return 0;
    };



    const getTotal = () => {
        // Initialize totals to zero
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
        let crate = 0;
        let weight = 0;

        let milkWeight = 0;
        let curdWeight = 0;
    
        orderData?.orderData?.forEach(data => {

            const price = parseFloat(data.itemPrice) || 0;
            const gst = parseFloat(data.itemGst) || 0;
            const disCrates = getDiscountCrates(data.itemId);
            
            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = parseFloat(price - productGst).toFixed(2) || 0;
    
            allTotal += price * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allGst += parseFloat( ((productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)) * (parseFloat(data.itemGst/2)/100)).toFixed(2) );
            allSubTotal += productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allQty += (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)|| 0;
            crate += (parseFloat(data.qty) + parseFloat(disCrates));
            weight +=  (((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight))/1000);
            
            if(data?.itemType === 'milk'){
                milkWeight += ((parseFloat(data.qty) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight))/1000);
            }

            if(data?.itemType === 'curd'){
                curdWeight += ((parseFloat(data.qty) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight))/1000);
            }
        });
    
        // Set the final values
        setTotal(allSubTotal);
        setGST(allGst);
        setGST2(parseFloat(allGst/2).toFixed(2));
        setQty(allQty);
        setGrandTotal(allTotal);
        setCrates(crate);
        setWeight(weight);
        getShipping(orderData?.dealerData?.id);
        setMilkWeight(milkWeight);
        setCurdWeight(curdWeight);
    };

    
    const updateVENums = async () => {
        const sendDatas = {
            orderId: orderId,
            vNum : vNum,
            eNum: eNum,
            address: dispatchAddress,
            shipping: shippingAddress,
            notes: notes
        };
        try {
			const response = await axios.post('https://api.trucoo.in/invoice/evnum/', sendDatas, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
                alert('Updated!');
				getOrder();
                cancel();
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };
    

    const changeStatus = async () => {
        try {
			const response = await axios.post('https://api.trucoo.in/invoice/payment/', {orderId: orderId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			//console.log(response.data);
			if(response.data.status === 'success'){
                alert('Updated!');
				getOrder();
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };

    const setInuputs = () => {
        if (orderData && orderData?.orderData) {
            const updatedCartItems = orderData.orderData.map((items) => ({
                product: items.itemId,
                qty: items.qty,
                itemGrade: items.itemGrade,
                type: items.discountType || null,
                values: items.discountValue || 0
            }));
    
            setInputData((prevData) => ({
                ...prevData, ...updatedCartItems,
            }));
        }
    };

    useEffect(()=> {
        getTotal();
        setInuputs();
    },[orderData]);

    useEffect(()=> {
        getTotal();
    },[discounts]);

    const changeQty = (item, qty) => {
        setInputData((prevData) => {
            const updatedData = { ...prevData }; 
            
            for (let key in updatedData) {
                if (updatedData[key].product === item) {
                    updatedData[key].qty = qty;
                    break;
                }
            }
    
            return updatedData;
        });
    };
    

	const changeQtyBtn = (item, value) => {
        setInputData((prevData) => {
            const updatedData = { ...prevData };
    
            for (let key in updatedData) {
                if (updatedData[key].product === item) {
                    if (value === 'plus') {
                        updatedData[key].qty = parseFloat(updatedData[key].qty) + 0.5;
                    } else {
                        updatedData[key].qty = parseFloat(updatedData[key].qty) - 0.5
                    }
    
                    break;
                }
            }
    
            return updatedData;
        });
    };

    const getNewTotal = () => {
        // Initialize totals to zero
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
    
        orderData?.orderData?.forEach((data, index) => {
            const price = parseFloat(data.itemPrice) || 0;
            const gst = parseFloat(data.itemGst) || 0;
            const disCrates = getDiscountCrates(data.itemId);
            const qty = parseFloat(Object.values(inputData).find(item => item.product === data.itemId)?.qty) || 0;

            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = parseFloat(price - productGst).toFixed(2) || 0;
    
            allTotal += price * (parseFloat(qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allGst += parseFloat((productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * (parseFloat(data.itemGst)/100)).toFixed(2));
            allSubTotal += productPrice * (parseFloat(qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allQty += (parseFloat(qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)|| 0;
            
        });
    
        // Set the final values
        setNewTotal(allSubTotal);
        setNewGst(allGst);
        setScheme(orderData?.schemeValue);
        getDiscount();
    };

    const getNewDiscounts = (product) => {
        
        const productData = orderData?.orderData?.find(items => items.itemId === product);
        const discountData = newDiscountData?.find(items => items.item === product); 
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.itemPrice);
        const crates = parseFloat(productData.itemGrade);
        const weight = parseFloat(productData.itemWeight);
        const gst = parseFloat(productData.itemGst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;

        if (!productData || !discountData) {
             //console.warn("Product or discount not found");
            return 0; 
        }

        if(discountData.discount !== 'amount'){
            return 0;
        }

        if(discountData.type === 'grade'){

            if(discountData.crate === 'packet'){
                return (parseFloat(productPrice) * parseFloat(discountData.value)) * parseFloat(qty)
            }else{
                return parseFloat(discountData.value) * parseFloat(qty)
            }
        }

        if(discountData.type === 'percent'){
            const total = parseFloat(qty) * parseFloat(crates)* parseFloat(productPrice);
            return total*(parseFloat(discountData.value)/100)
        }

        if(discountData.type === 'liters'){

            if(discountData.crate === 'litre'){
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                const weights = litters * discountData.value;
                const ltr = (weights * 1000) / weight;
                return ltr * productPrice
            }else{
                const litters = (parseFloat(qty) * parseFloat(crates)) * (parseFloat(weight)/1000)
                return litters * discountData.value
            }
        }

        if(discountData.type === 'packet'){
            const values = parseFloat(discountData.value);
            const disQty = parseFloat(qty) * parseFloat(crates);
            return disQty * values;
        }

        return 0;
    };

    const getDisc = (product) => {
        const discountData = newDiscountData?.find(items => items.item === product); 
        if (!discountData) {
            const disc = 'No Discount';
            return disc; 
        }
        const dics = `${discountData?.discount} ${discountData?.value}/${discountData?.type === 'grade' ? 'Crates' : discountData?.type}`;
        return dics;
    };

    const getDiscount = () => {

        let discount = 0;

        orderData?.orderData?.forEach((data, index) => {
            discount += getNewDiscounts(data.itemId) || 0;
        });

        setNewDiscount(parseFloat(discount) + parseFloat(scheme));
    };

    useEffect(() => {
        getNewTotal();
        getDiscount();
    },[inputData, scheme, orderData, newDiscountData]);

    
    const placeOrder = async () => {
        
        const sendData = {
            orderId: orderId,
            total: parseFloat(parseFloat(newTotal) + parseFloat(newGst)),
            gst: newGst,
            discountData: newDiscountData,
            items: inputData,
            discountValue: newDiscount,
            olDiscountData: discountData,
            user: userID
        }
        try{
            const response = await axios.post('https://api.trucoo.in/invoice/edit/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

			//console.log(response.data);

            if(response.data.status === 'success'){
                getOrder();
                setEdit(!edit);
            }

        } catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };

    // const downloadPDF = () => {
    //     const invoiceElement = document.getElementById("printableArea");
    //     invoiceElement.classList.remove("hide");

    //     html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
    //       const imgData = canvas.toDataURL("image/png");
    //       const pdf = new jsPDF("p", "mm", "a4");
    
    //       const pdfWidth = pdf.internal.pageSize.getWidth();
    //       const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    
    //       pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    //       pdf.save(`${orderData?.dealerData?.id}-${formatNumber(orderData?.id, 6)}-${orderData?.date}`);
    //       invoiceElement.classList.add("hide");
    //     });
    // };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            //console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
		return formattedDate;
	};

    const formatSlashViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            //console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${newDate.getFullYear()}`;
		return formattedDate;
	};

    const fiscalYear = getFiscalYearLabel(new Date(orderData?.date));

    const downloadCombinedPDF = async (option) => {
        setLoader(true);
        setWhatsAppNum(false);

        let sections = [];

        if (option === 'whatsapp' || option === 'view'){
            sections = [ document.getElementById("printableArea1") ];
        }
        if(option === 'print' || option === 'download'){
            sections = selectedSections.map(id => document.getElementById(id));
        };

        // const sections = [
        //     document.getElementById("printableArea1"),
        //     //document.getElementById("printableArea2"),
        //     document.getElementById("printableArea3"),
        //     document.getElementById("printableArea4")
        // ];
         
        // Unhide all sections
        sections.forEach(el => el.classList.remove("hide"));
         
        const pdf = new jsPDF("p", "mm", "a4");
         
        for (let i = 0; i < sections.length; i++) {
            const element = sections[i];
            const canvas = await html2canvas(element, { useCORS: true, logging: false, scale: 5 });
            const imgData = canvas.toDataURL("image/jpeg");
         
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
         
            if (i > 0) pdf.addPage();
                pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
        }
         
        
        const filename = `${orderData?.dealerData?.dealer}-TRC/${orderData?.invoiceId}/${fiscalYear}/${formatViewDate(orderData?.date)}`;

        if(option === 'download'){
            pdf.save(filename);
        }

        if(option === 'print'){
            pdf.autoPrint();
            window.open(pdf.output("bloburl"), '_blank');
        }

        if(option === 'view'){
            window.open(pdf.output("bloburl"), '_blank');
            sections.forEach(el => el.classList.add("hide"));
            setLoader(false);
            return;
        }

        if(option === 'printview'){
            pdf.autoPrint();
            window.open(pdf.output("bloburl"), '_blank');
            sections.forEach(el => el.classList.add("hide"));
            setLoader(false);
            return;
        }

        if(option === 'whatsapp'){

            const onlyDigits = newWhatsappNum.replace(/\D/g, '');

            if (onlyDigits.length < 10) {
                alert('Invalid Mobile Number!');
                setLoader(false);
                setWhatsAppNum(true);
                return;
            }
            //pdf.autoPrint();
            //window.open(pdf.output("bloburl"), '_blank');
            const pdfBlob = pdf.output("blob");
            const formData = new FormData();
            formData.append("file", pdfBlob, `${orderId}.pdf`);
            formData.append("pdfName", filename); 
            formData.append("orderId", orderId); 
            formData.append("name", orderData?.dealerData?.dealer); 
            formData.append("date", orderData?.date); 
            formData.append("phone", newWhatsappNum); 
            formData.append("user", userID); 

            try{
                const response = await axios.post('https://api.trucoo.in/invoice/upload-pdf/', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });

                // console.log(response.data);

                if(response.data.status === 'success'){
                    alert('Invoice Sent successfully!');
                }else{
                    alert('Something went wrong! Please try again.');
                }

            } catch (error) {
                console.error("Error:", error.response || error.message);
            }
            sections.forEach(el => el.classList.add("hide"));
            setLoader(false);
            return;
        }
        
         
        // Re-hide all sections
        sections.forEach(el => el.classList.add("hide"));
        setLoader(false);
    };

    const manageInvoice = () => {
        setShowPopup(true);
    };

    const cancel = () => {
		setShowPopup(false);
	};

    const wpCancel = () => {
        setWhatsAppNum(false);
        setLoader(false);
    };

    const eWBcancel = () => {
		setEwbPop(false);
	};

    const removeItem = async (itemId) => {
        const sendData = {
            orderId: orderId,
            itemId: itemId
        }

        try {
            const response = await axios.post('https://api.trucoo.in/invoice/remove-item/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            if(response.data.status === 'success'){
                getOrder();
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }

    };

    const askEdit = async() => {
        const sendData = {
            type: 'request',
            orderId: orderId,
            user: userID,
            userName: userName,
            invNo: `TRC/${orderData?.invoiceId}/${fiscalYear}`,
            reason: invEditReason
        };

        try {
            const response = await axios.post('https://api.trucoo.in/invoice/edit-approve/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            if(response.data.status === 'success'){
                getOrder();
                //setInvEdit(false);
                setInvEditStatus(response?.data?.data?.message);
            }else{
                alert('Unable to update your request please try again!');
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        
    };

    const approve = async() => {
        const sendData = {
            type: 'approve',
            orderId: orderId,
            user: userID,
            userName: userName
        };

        try {
            const response = await axios.post('https://api.trucoo.in/invoice/edit-approve/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            if(response.data.status === 'success'){
                getOrder();
                
            }else{
                alert('Unable to update your request please try again!');
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    //console.log(orderData);

    const formatDateEWB = (dateStr) => {
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatViewInptDate = (date) => {
        console.log(date);
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getFullYear()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getDate()}`;
		return formattedDate;
	};

    const eWayBillData = async(e) => {
        console.log('Creating E Way Bill...');
        e.preventDefault();
        setLoader(true);

        if(!(orderData?.dealerData?.pincode) || (orderData?.dealerData?.pincode).length <= 0){
            setEWBError('Invalid Pincode for Party!');
            return;
        }

        const itemList = orderData?.orderData?.map(items => ({
            productName: items?.itemName,
            productDesc: items?.itemCode,
            hsnCode: items?.itemHsn,
            quantity: (parseFloat(items?.itemGrade) * parseFloat(items?.qty)),
            qtyUnit: "NOS",
            taxableAmount: Number(parseFloat((items?.itemGrade) * parseFloat(items?.qty) * parseFloat(items?.itemPrice)).toFixed(2)),
            sgstRate: Number(parseFloat((orderData?.dealerData?.gstType === 'SGST' ? parseFloat(items?.itemGst/2) : 0).toFixed(2))),
            cgstRate: Number(parseFloat((orderData?.dealerData?.gstType === 'SGST' ? parseFloat(items?.itemGst/2) : 0).toFixed(2))),
            igstRate: Number(parseFloat((orderData?.dealerData?.gstType === 'SGST' ? 0 :  parseFloat(items?.itemGst)).toFixed(2))),
            cessRate: 0,
        }));

        const eWayBillData = {
            supplyType: ewbInputs?.supplyType,
            subSupplyType: ewbInputs?.subSupplyType,
            subSupplyDesc: " ",
            docType: ewbInputs?.docType,
            docNo: ewbInputs?.docNo,
            docDate: formatDateEWB(ewbInputs?.docDate),
            fromGstin: '33AAKCT9681P1ZC',
            fromTrdName: 'TRUCOO DAIRY PRODUCTS PRIVATE LIMITED',
            fromAddr1: 'C201, SK Hill view Apartment',
            fromAddr2: 'Rainbow Enclave, Rainbow Colony,Myilkal, Sugunapuram, Coimbatore,C 201,Coimbatore,Tamil Nadu',
            fromPlace: 'Coimbatore',
            actFromStateCode: 33,
            fromPincode:  641008,
            fromStateCode:  33,
            ...(orderData?.dealerData?.gst?.length > 10 ? {
                toGstin: orderData?.dealerData?.gst,
            } : {toGstin: 'URP'}),
            toTrdName: orderData?.dealerData?.dealer,
            toAddr1: orderData?.dealerData?.address,
            toAddr2: orderData?.dealerData?.locations,
            toPlace: orderData?.dealerData?.locations,
            toPincode:  Number(orderData?.dealerData?.pincode),
            actToStateCode:  Number(orderData?.dealerData?.stateCode),
            toStateCode: Number( orderData?.dealerData?.stateCode),
            transactionType: 4,
            dispatchFromGSTIN: "33AAKCT9681P1ZC",
            dispatchFromTradeName: orderData?.dispatch?.company,
            ...(orderData?.shipping?.gstin?.length > 10 && {
                shipToGSTIN: orderData?.shipping?.gstin,
            }),
            shipToTradeName: orderData?.shipping?.company,
            totalValue: Number((parseFloat(orderData?.totalPayment) - parseFloat(orderData?.gst)).toFixed(2)),
            cgstValue: Number(orderData?.dealerData?.gstType === 'SGST' ? (parseFloat(orderData?.gst)/2).toFixed(2) : 0),
            sgstValue: Number(orderData?.dealerData?.gstType === 'SGST' ? (parseFloat(orderData?.gst)/2).toFixed(2) : 0),
            igstValue: Number(orderData?.dealerData?.gstType === 'SGST' ? 0 : parseFloat(orderData?.gst).toFixed(2)),
            // cessValue: 0,
            // cessNonAdvolValue: 0,
            totInvValue:  Number(parseFloat(orderData?.totalPayment).toFixed(2)),
            transMode: ewbInputs?.transMode,
            transDistance: '0',
            ...(ewbInputs?.transporterName?.length > 0 && {
                transporterName: ewbInputs?.transporterName,
            }),
            ...(ewbInputs?.transporterId?.length > 0 && {
                transporterId: ewbInputs?.transporterId,
            }),
            ...(ewbInputs?.transDocNo?.length > 0 && {
                transDocNo: ewbInputs?.transDocNo,
            }),
            ...(ewbInputs?.transDocDate?.length > 0 && {
                transDocDate: ewbInputs?.transDocDate,
            }),
            vehicleNo: orderData?.vNum,
            vehicleType: ewbInputs?.vehicleType,
            itemList: itemList
        };

         try {
            const response = await axios.post('https://api.trucoo.in/ewaybill/', ewbInputs, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            console.log(response.data);
        } catch (err) {
            console.error(err);
            console.error('Failed to fetch distance.');
        }

        console.log(eWayBillData);

        newEWayBill?.createAuthToken().then(res => {
            console.log("Token Response:", res);

            if(res?.status_cd === '1'){
                newEWayBill?.generateEwayBill(eWayBillData).then(res => {
                    console.log("E-Way Bill Response:", res);
                    updateEWayBill(res?.data);
                });
            }
        });
        setLoader(false);
       
    };

    // console.log(orderData?.eWayNum);

    const validateInvoice = (data) => {
        const errors = [];

        const checkFields = (obj, path = "") => {
            Object.keys(obj).forEach((key) => {
            const value = obj[key];
            const currentPath = path ? `${path}.${key}` : key;

            // Skip allowed nullable field
            if (key === "EcmGstin") return;

            // ✅ Check empty
            if (
                value === null ||
                value === undefined ||
                value === "" ||
                (typeof value === "number" && Number.isNaN(value))
            ) {
                errors.push(`${currentPath} is invalid or empty`);
            }

            // Nested object
            else if (typeof value === "object" && !Array.isArray(value)) {
                checkFields(value, currentPath);
            }

            // Array
            else if (Array.isArray(value)) {
                if (value.length === 0) {
                errors.push(`${currentPath} is empty`);
                } else {
                value.forEach((item, index) => {
                    checkFields(item, `${currentPath}[${index}]`);
                });
                }
            }
            });
        };

        checkFields(data);
        return errors;
        };

    const updateEinv = async (data) => {
        const sendData = {
            "orderId": orderData?.orderId,
            "status": data?.Status,
            "irn": data?.Irn,
            "data": data,
            "signed": data?.SignedQRCode,
            "akNo": data?.AckNo
        };

        try {
            const response = await axios.post('https://api.trucoo.in/e-invoice/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            
            getOrder();
        } catch (err) {
            console.error(err);
            console.error('Failed to fetch distance.');
        }
    };

    const eInvData = async () => {

        const getSupplyType = (buyerGstin) => {
            if (!buyerGstin || buyerGstin === "URP") {
                return null; // Don't generate e-invoice
            }
            return "B2B";
        };

        const supplyType = getSupplyType(orderData?.dealerData?.gst);

        if (!supplyType) {
            console.log("Skip e-Invoice for B2C");
            return;
        }

        let totalAmount = 0;
        let iGstTotal = 0;
        let cGstTotal = 0;
        let sGstTotal = 0;
        let discountTotal = 0;

        const itemList = orderData?.orderData?.map((items, index) => {

            const qty = Number((Number(items?.qty || 0) * Number(items?.itemGrade || 0)).toFixed(2));
            const price = Number(items?.itemPrice || 0);
            const gst = Number(items?.itemGst || 0);

            const discount = getNewDiscounts(items.itemId);

            // Remove GST from price (inclusive price)
            const productGst = price - (price / (1 + gst / 100));
            const productPrice = Number((price - productGst).toFixed(2));

            // const total = (qty * productPrice) - discount;
            const total = qty * productPrice;

            const isSGST = orderData?.dealerData?.gstType === "SGST";
            const gstAmount = total * (gst / 100);

            const sGst = isSGST ? Number((gstAmount / 2).toFixed(2)) : 0;
            const cGst = isSGST ? Number((gstAmount / 2).toFixed(2)) : 0;
            const iGst = !isSGST ? Number((gstAmount).toFixed(2)) : 0;

            const gTotal = total + sGst + cGst + iGst;

            // Accumulate totals
            totalAmount += total;
            sGstTotal += sGst;
            cGstTotal += cGst;
            iGstTotal += iGst;
            discountTotal += discount;

            return {
                SlNo: (index + 1).toString(),
                IsServc: "N",
                PrdDesc: items?.itemName,
                HsnCd: items?.itemHsn,
                Qty: qty,
                Unit: "NOS",
                UnitPrice: Number(productPrice.toFixed(2)),
                TotAmt: Number(total.toFixed(2)),
                AssAmt: Number(total.toFixed(2)),
                GstRt: gst,
                SgstAmt: Number(sGst.toFixed(2)),
                IgstAmt: Number(iGst.toFixed(2)),
                CgstAmt: Number(cGst.toFixed(2)),
                TotItemVal: Number(gTotal.toFixed(2)),
                OrdLineRef: items?.id,
                OrgCntry: "IN",
                PrdSlNo: items?.itemCode,
                AttribDtls: [
                    {
                        Nm: items?.itemName,
                        Val: items?.itemCode
                    }
                ]
            };

        }) || [];

        const billTotal = totalAmount - discountTotal;
        const finalTotal = billTotal + sGstTotal + cGstTotal + iGstTotal;
        const roundOff = Math.round(finalTotal);
        const rounded = Number((roundOff - finalTotal).toFixed(2));

        const getAddress = (address) => {
            const words = address.split(" ");
            const middleIndex = Math.ceil(words.length / 2);

            const adrs1 = words.slice(0, middleIndex).join(" ");
            const adrs2 = words.slice(middleIndex).join(" ");

            return { adrs1, adrs2 };
        };

        const { adrs1: ship1, adrs2: ship2 } =getAddress(orderData?.shipping?.address || "");
        const { adrs1: disp1, adrs2: disp2 } = getAddress(orderData?.dispatch?.address || "");
        const { adrs1: bill1, adrs2: bill2 } = getAddress(orderData?.dealerData?.address || "");

        const formatIndianMobile = (phone = "") => {
            // Remove all non-digit characters (space, +, -, etc.)
            let cleaned = phone.replace(/\D/g, "");

            // If number starts with 91 and length > 10 → remove 91
            if (cleaned.startsWith("91") && cleaned.length > 10) {
                cleaned = cleaned.slice(2);
            }

            // If number starts with 0 and length > 10 → remove 0
            if (cleaned.startsWith("0") && cleaned.length > 10) {
                cleaned = cleaned.slice(1);
            }

            // Keep last 10 digits only
            cleaned = cleaned.slice(-10);

            return cleaned;
        };

        const invData = {
            "Version": "1.1",
            "TranDtls": {
                "TaxSch": "GST",
                "SupTyp": supplyType,
                "RegRev": "N",
                "EcmGstin": null,
                "IgstOnIntra": "N"
            },
            "DocDtls": {
                "Typ": "INV",
                "No": `TRC/${orderData?.invoiceId}/${fiscalYear}`,
                "Dt": `${formatSlashViewDate(orderData?.date)}`
            },
            "SellerDtls": {
                "Gstin": "33AAKCT9681P1ZC",
                "LglNm": "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
                "TrdNm": "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
                "Addr1": "C201, SK Hill view Apartment",
                "Addr2": "Rainbow Enclave, Rainbow Colony, Myilkal, Sugunapuram",
                "Loc": "Coimbatore",
                "Pin": 641008,
                "Stcd": "33",
                "Ph": "8190003400",
                "Em": "cbeoffice@trucoo.in"
            },
            "BuyerDtls": {
                "Gstin": `${orderData?.dealerData?.gst}`,
                "LglNm": `${orderData?.dealerData?.dealer}`,
                "TrdNm": `${orderData?.dealerData?.dealer}`,
                "Pos": `${orderData?.dispatch?.code}`,
                "Addr1": `${bill1}`,
                "Addr2": `${bill2}`,
                "Loc": `${orderData?.dealerData?.locations}`,
                "Pin": Number(orderData?.dealerData?.pincode),
                "Stcd": `${orderData?.dealerData?.stateCode}`,
                // "Ph": `${formatIndianMobile(orderData?.dealerData?.phone)}`,
                "Em": `${orderData?.dealerData?.email}`
            },
            "DispDtls": {
                "Nm": `${orderData?.dispatch?.company}`,
                "Addr1": `${disp1}`,
                "Addr2": `${disp2}`,
                "Loc": `${orderData?.dispatch?.location}`,
                "Pin": Number(orderData?.dispatch?.pin),
                "Stcd": `${orderData?.dispatch?.code}`
            },
            "ShipDtls": {
                "Gstin": `${orderData?.dealerData?.gst}`,
                "LglNm": `${orderData?.shipping?.company}`,
                "TrdNm": `${orderData?.shipping?.company}`,
                "Addr1": `${ship1}`,
                "Addr2": `${ship2}`,
                "Loc": `${orderData?.shipping?.location}`,
                "Pin": Number(orderData?.shipping?.pin),
                "Stcd": `${orderData?.dealerData?.stateCode}`
            },
            "ItemList": itemList,
            "ValDtls": {
                "AssVal": Number(totalAmount.toFixed(2)),
                "CgstVal": Number(cGstTotal.toFixed(2)),
                "SgstVal": Number(sGstTotal.toFixed(2)),
                "IgstVal": Number(iGstTotal.toFixed(2)),
                "RndOffAmt": Number(rounded.toFixed(2)),
                "TotInvVal": Number(roundOff.toFixed(2)),
                "Discount": Number(discountTotal.toFixed(2))
            }
        };

        if (orderData?.eWayNum?.length > 1) {
            invData.EwbDtls = {
                Transid: orderData?.eWayNum,
                Transname: "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
                Distance: Number(orderData?.ewb?.dist),
                Transdocno: orderData?.ewb?.docNo,
                TransdocDt: orderData?.ewb?.docDate,
                Vehno: orderData?.ewb?.vNum,
                Vehtype: orderData?.ewb?.vType,
                TransMode: orderData?.ewb?.tMode,
            };
        }

        const errors = validateInvoice(invData);

        if (errors.length > 0) {
            console.log("Validation Errors:", errors);
            setINVError(errors[0]); // show first error
            return;
        }
    
        generateInvoice(invData);
    
    };

    const generateInvoice = async (invData) => {

        setLoader(true);
        try {
            const response = await axios.post('https://api.trucoo.in/e-invoice/generate/', invData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
            });

            console.log(response?.data);

            if(response?.data?.status_cd === '1'){
                updateEinv(response?.data?.data);
            }else{
                alert('Unable to Create E-Invoice, Please try again!');
            }
                
        } catch (error) {
            console.error("Error:", error);
        }
        setLoader(false);
    };



    const cancelInvoice = async () => {

        const invData = {
              "Irn": orderData?.eInvNo,
              "CnlRsn": "1",
              "CnlRem": orderData?.reason
            }

        try {
            const res = await newEWayBill?.createInvAuthToken();

            if (res?.status_cd === "Success" || res?.status_cd === '1') {
                const authToken = res?.data?.AuthToken;
                console.log(authToken);

                const invResult = await newEWayBill?.cancelEinvoice(
                    authToken,
                    invData
                );

                console.log(invResult);

                if(invResult?.status_cd === '1'){
                    console.log('success');
                }else{
                    const error = JSON.parse(invResult?.status_desc || []);
                    setINVError(error[0]?.ErrorMessage);
                }
                
            } else {
                console.log("Token generation failed", res);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    };

    const newData = (e) => {
        const { name, value } = e.target;
        setEWBInputs((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    useEffect(() => {
        setEWBInputs((prevData) => ({
          ...prevData,
          ['fromGstin']: '33AAKCT9681P1ZC',
          ['supplyType']: orderData?.ewb?.sType || '',
          ['subSupplyType']: orderData?.ewb?.ssType || '',
          ['docType']: orderData?.ewb?.docType || '',
          ['docNo']: orderData?.ewb?.docNo || `TRC/${orderData?.invoiceId}/${fiscalYear}`,
          ['docDate']: orderData?.ewb?.docDate || orderData?.date,
          ['transDistance']: orderData?.ewb?.dist || '',
          ['transporterName']: orderData?.ewb?.tName || '',
          ['transporterId']: orderData?.ewb?.tId || '',
          ['transDocNo']: orderData?.ewb?.tdNo || '',
          ['vehicleNo']: orderData?.ewb?.vNum || orderData?.vNum || '',
          ['vehicleType']: orderData?.ewb?.vType || '',
          ['transMode']: orderData?.ewb?.tMode || '',
          ['orderId']: orderId,
        }));
    },[orderData]);

    const getDistance = async () => {
        const origin = orderData?.dispatch?.pin;
        const destination = orderData?.shipping?.pin;

        if(!origin || origin?.length <= 0 || !destination || destination?.length <= 0){
            setDisterror('Invalid pincode! Please check pincode for Shipping address!');
            return;
        }
        const sendData = {
            origin: origin,
            destination: destination
        };

        try {
            const response = await axios.post('https://api.trucoo.in/distance/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
            const element = response.data.data.rows[0].elements[0];
            if (element.status === 'OK') {
                const distanceText =  parseFloat(element.distance.text);
                setEWBInputs((prevData) => ({
                    ...prevData,
                    ['transDistance']: distanceText,
                }));
            } else {
                setEWBInputs((prevData) => ({
                    ...prevData,
                    ['transDistance']: 0,
                }));
                console.error('No route found between the locations.');
            }
        } catch (err) {
            console.error(err);
            console.error('Failed to fetch distance.');
        }
    };

    const extractDistance = (input) => {
        if (input.toLowerCase().includes('distance')) {
            const match = input.match(/\d+/);
            if (match) {
                return match[0]; // returns '141' as string
            }
        }
        return 0;
    };

    const updateEWayBill = async(data) => {
        const distance = extractDistance(data?.alert|| '');
        const sendData = {
            data: data,
            ewayNum: data?.ewayBillNo || '',
            create: data?.ewayBillDate || '',
            valid: data?.validUpto || '',
            orderId: orderId,
            dist: distance
        };

        //console.log(data);

        try{
            const response = await axios.post('https://api.trucoo.in/ewaybill/success/', sendData, {
                headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

        } catch (err) {
            console.error(err);
            console.error('Failed to fetch distance.');
        }
        getOrder();
    };

    const cancelInvoiceRequest = async() => {


        const sendData = {
            type: 'cancel',
            orderId: orderId,
            user: userID,
            userName: userName,
            invNo: `TRC/${orderData?.invoiceId}/${fiscalYear}`,
            reason: invCancelReason
        };
        try {
            const response = await axios.post('https://api.trucoo.in/invoice/edit-approve/', sendData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo' 
                }
            });
            if(response.data.status === 'success'){
                getOrder();
                setInvCancelStatus('Invoice Cancel Request Sent!');
                // cancelInvoice();
            }
        } catch (err) {
            console.error(err);
            console.error('Failed to send cancel request.');
        }
    };



return(
<>
{loader && <Loader /> }
   <div className="overlay" style={{ display: showPopup ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '700px', maxHeight: '90vh',overflowY: 'scroll'  }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={cancel} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">Manage Invoice</h4>
            <div class="row mt-4 text-start">
                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                <div class="form-group">
                    <label>Vehicle No</label>
                    <input type="text" class="form-control" placeholder='Enter vehicle Number' value={vNum} onChange={(e)=> setVNum(e.target.value)} />
                </div>
                </div>
                <div class="col-6 col-md-6 col-xl-6 col-xxl-6">
                <div class="form-group">
                    <label>E-Way Bill No</label>
                    <input type="text" class="form-control" placeholder='Eneter E-Way Bill Number' value={eNum} onChange={(e)=> setENum(e.target.value)} />
                </div>
                </div>
                <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-2">
                <div class="form-group">
                    <label>Select Dispatch Address</label>
                    {address?.map(adrs => 
                    <div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${dispatchAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
				        <input type="radio" id={adrs.id} name="dispatchAddress" value={adrs.id} checked={dispatchAddress === adrs.id ? true : false} onChange={(e)=> setDispatchAddress(e.target.value)} />
				        <label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
                    </div>
                    )}
                </div>
                </div>

                 <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-2">
                <div class="form-group">
                    <label>Select Shipping Address</label>
                    {shipping?.map(adrs => 
                    <div for={adrs.id} style={{padding: '10px', margin: '10px 0px', border: `${shippingAddress === adrs.id ? '2px solid  #dbc359' : '1px solid  #333'}`, borderRadius: '10px'}}>
				        <input type="radio" id={adrs.id} name="shippingAddress" value={adrs.id} checked={shippingAddress === adrs.id ? true : false} onChange={(e)=> setShippingAddress(e.target.value)} />
				        <label for={adrs.id} class="text-dark fs-11">{adrs.company} {adrs.address}</label>
                    </div>
                    )}
                </div>
                </div>

                <div class="col-12 col-md-12 col-xl-12 col-xxl-12 mt-2">
                <div class="form-group">
                    <label>Notes for Invoice</label>
                   <textarea class="form-control" name="notes" onChange={(e)=>setNotes(e.target.value)} value={notes} ></textarea>
                </div>
                </div>
                
            </div>
            
            
            <button class="btn btn-success" onClick={updateVENums}>Update</button>
        </div>
    </div>

    <div className="overlay" style={{ display: whatsappNum ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '700px', maxHeight: '90vh',overflowY: 'scroll'  }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={wpCancel} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">WhatsApp Number</h4>
            <div class="row mt-4 text-start">
               <div class="col-lg-3"></div>
               <div class="col-lg-6">
                <label>Enter WhatsApp Number</label>
                <input type="number" class="form-control mt-2" value={newWhatsappNum} onChange={(e)=>setNewWhatsAppNum(e.target.value)} />
               </div>
               <div class="col-lg-3"></div>
                
            </div>
            <button class="btn btn-success mt-4" disabled={newWhatsappNum?.length < 10} onClick={()=>{downloadCombinedPDF('whatsapp')}}><i class="fa fa-whatsapp"></i> Send WhatsApp</button>
        </div>
    </div>

    <div className="overlay" style={{ display: ewbPop ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '80%', maxHeight: '90vh',overflowY: 'scroll'  }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={eWBcancel} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">Generate E-Way Bill</h4>
            <form onSubmit={eWayBillData}>
            <div class="row mt-4 text-start">
                <div class="col-lg-3 mt-2">
                    <p>Invoice From</p>
                    <p class="fs-10">
                        <b>TRUCOO DAIRY PRODUCTS PRIVATE LIMITED</b> <br />
                        C201, SK Hill view Apartment, 
                        Rainbow Enclave, Rainbow Colony, Myilkal, Sugunapuram, Coimbatore, Tamil Nadu<br />
                        GSTIN : 33AAKCT9681P1ZC
                    </p>
                </div>
                <div class="col-lg-3 mt-2">
                    <p>Invoice To</p>
                    <p class="fs-10">
                        <b>{orderData?.dealerData?.dealer} </b><br />
                        {orderData?.dealerData?.address}<br />
                        GSTIN : {orderData?.dealerData?.gst}<br />
                        PIN : {orderData?.dealerData?.pincode}
                    </p>
                </div>
                <div class="col-lg-3 mt-2">
                    <p>Dispatch From</p>
                    <p class="fs-10">
                        <b>{orderData?.dispatch?.company}</b><br />
                        {orderData?.dispatch?.address}<br />
                        PIN : {orderData?.dispatch?.pin}
                    </p>
                </div>
                <div class="col-lg-3 mt-2">
                    <p>Ships To</p>
                    <p class="fs-10">
                        <b>{orderData?.shipping?.company}</b><br />
                        {orderData?.shipping?.address}<br />
                        GSTIN : {orderData?.shipping?.gstin}<br />
                        PIN : {orderData?.shipping?.pin}
                    </p>
                </div>
                <hr class="m-2" />
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Supply Type</label>
                    <select class="form-select" name="supplyType" value={ewbInputs?.supplyType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="O">Outward-Supply</option>
                        <option value="I">Inward-Supply</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Sub-Supply Type</label>
                    <select class="form-select" name="subSupplyType" value={ewbInputs?.subSupplyType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="1">Supply</option>
                        <option value="2">Import</option>
                        <option value="3">Export</option>
                        <option value="4">Job Work</option>
                        <option value="5">For Own Use</option>
                        <option value="6">Job Work Returns</option>
                        <option value="7">Sales Return</option>
                        <option value="8">Others</option>
                        <option value="9">SKD/CKD/Lots</option>
                        <option value="10">Line Sales</option>
                        <option value="11">Recipient Not Known</option>
                        <option value="12">Exhibition or Fairs</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Document Type</label>
                    <select class="form-select" name="docType" value={ewbInputs?.docType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="INV">Invoice</option>
                        <option value="CHL">Delivery Chellan</option>
                        <option value="BIL">Bill of Supply</option>
                        <option value="BOE">Bill of Entry</option>
                        <option value="OTH ">Others</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Document No</label>
                    <input type="text" class="form-control" name="docNo" value={ewbInputs?.docNo} onChange={(e)=>newData(e)} required />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Document Date</label>
                    <input type="date" class="form-control" name="docDate" value={ewbInputs?.docDate} onChange={(e)=>newData(e)} required />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Distance</label>
                    <div class="input-group">
                        <input type="text" class="form-control" name="transDistance" value={ewbInputs?.transDistance} onChange={(e)=>newData(e)} required />
                        <button type="button" class="btn btn-sm btn-success" onClick={getDistance}>Get Distance</button>
                    </div>
                    {distError && distError?.length > 0 && <p class="fs-10 text-danger">{distError}</p> }
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Transporter Name</label>
                    <input type="text" class="form-control" name="transporterName" value={ewbInputs?.transporterName} onChange={(e)=>newData(e)} />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Transporter ID</label>
                    <input type="text" class="form-control" name="transporterId" value={ewbInputs?.transporterId} onChange={(e)=>newData(e)}  />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Transporter Doc No</label>
                    <input type="text" class="form-control" name="transDocNo" value={ewbInputs?.transDocNo} onChange={(e)=>newData(e)}  />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Vehicle Number</label>
                    <input type="text" class="form-control" name="vehicleNo" value={ewbInputs?.vehicleNo} onChange={(e)=>newData(e)} required />
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Vehicle Type</label>
                    <select class="form-select" name="vehicleType" value={ewbInputs?.vehicleType} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="R">Regular</option>
                        <option value="O">ODC(Over Dimentional Cargo)</option>
                    </select>
                </div>
                <div class="col-lg-3 mt-2">
                    <label class="form-label">Trsnsport Mode</label>
                    <select class="form-select" name="transMode" value={ewbInputs?.transMode} onChange={(e)=>newData(e)} required >
                        <option value="">Select an Option</option>
                        <option value="1">Road</option>
                        <option value="2">Rail</option>
                        <option value="3">Air</option>
                        <option value="4">Ship</option>
                    </select>
                </div>
                {orderData?.eWayNum === '' || orderData?.eWayNum === null || !orderData?.eWayNum || orderData?.eWayNum?.length <= 8 ?
                    <div class="col-lg-12 mt-2" align="center">
                        <button type="submit" class="btn btn-success mt-4">Create E-Way Bill</button>
                        {ewbError && ewbError.length > 0 && <p class="fs-12 text-danger text-center mt-2">{ewbError}</p> }
                    </div>
                    : <h5 class="mt-4 text-center">E-Way Bill No : {orderData?.eWayNum}</h5>
                }
            </div>
            </form>
        </div>
    </div>


    <div className="overlay" style={{ display: invCancelPop ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '700px', maxHeight: '90vh',overflowY: 'scroll'  }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => setInvCancelPop(false)} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">Cancel Invoice</h4>
            <div class="row mt-4 text-start">
               <div class="col-lg-12">
                <label>Enter the Reason for Cancellation</label>
                <textarea class="form-control mt-2" rows="6" value={invCancelReason} onChange={(e)=>setInvCancelReason(e.target.value)} />
               </div>
            </div>
            <button class="btn btn-success mt-4" disabled={invCancelReason?.length < 5} onClick={()=>{cancelInvoiceRequest()}}> Request for Cancellation</button>
            {einvCanError && <p className='text-danger mt-2 mb-2'>{einvCanError}</p>}
            {invCancelStatus?.length > 0 && <p className="fs-10 text-success">{invCancelStatus}</p>}
        </div>
    </div>

    <div className="overlay" style={{ display: invEdit ? 'flex' : 'none', overflowY: 'scroll'}}>
        <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '700px', maxHeight: '90vh',overflowY: 'scroll'  }}>
            <button className="btn btn-danger" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => setInvEdit(false)} > <i className="fa fa-close"></i></button>
            <h4 className="text-bold mb-2">Edit Invoice</h4>
            <div class="row mt-4 text-start">
               <div class="col-lg-12">
                <label>Enter the Reason for Edit</label>
                <textarea class="form-control mt-2" rows="6" value={invEditReason} onChange={(e)=>setInvEditReason(e.target.value)} />
               </div>
            </div>
            <button class="btn btn-success mt-4" disabled={invEditReason?.length < 5} onClick={()=>{askEdit()}}> Request for Edit</button>
            {invEditStatus?.length > 0 && <p className="fs-10 text-success">{invEditStatus}</p>}
        </div>
    </div>


    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">

			<div class="box">
                <div class="box-header with-border">
				  <h4 class="box-title">Invoice Details</h4>
				  <p class="mb-0 box-subtitle">Ref ID : {orderId}</p>
                  <p class="mb-0 box-subtitle">Date : {formatViewDate(orderData?.date)}</p>
                  <p class="mb-0 box-title">Invoice No : TRC/{orderData?.invoiceId}/{fiscalYear}</p>
                  
				</div>
                <div class="box-body">
                    <div class="row">
                        <div class="col-lg-12 mt-4" style={{border: '1px solid #333', borderRadius: '10px', padding: '20px 25px'}}>
                            <div class="row">
                                <div class="col-lg-5 mt-2 fs-12">
                                
                                        <h6>Invoice To</h6>
                                        <small> <b>{orderData?.dealerData?.dealer}</b><br />
                                            {orderData?.dealerData?.address}<br />
                                            {orderData?.dealerData?.gst} <br /> {orderData?.dealerData?.locations}<br />
                                            {orderData?.dealerData?.phone}, {orderData?.dealerData?.email}
                                        </small> 

                                        <h6 class="mt-4">Ships To</h6>
                                        <small> <b>{orderData?.shipping?.company}</b><br />
                                            {orderData?.shipping?.address}<br />
                                            {orderData?.shipping?.gstin} <br /> {orderData?.shipping?.location}<br />
                                            {orderData?.shipping?.phone}, {orderData?.shipping?.email}
                                        </small> 

                                        <h6 class="mt-4">Dispatch From</h6>
                                        <small> <b>{orderData?.dispatch?.company}</b><br />
                                            {orderData?.dispatch?.address}<br />
                                            33AAKCT9681P1ZC <br /> {orderData?.dispatch?.location}<br />
                                            {orderData?.dispatch?.phone}, {orderData?.dispatch?.email}
                                        </small> 
                                 
                                </div>

                                <div class="col-lg-3 mt-2 fs-12">
                                    <table width="100%">
                                        <tr>
                                            <td style={{padding: '5px'}}>Sub Total</td>
                                            <td style={{padding: '5px'}}>₹ {parseFloat(total).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>GST</td>
                                            <td style={{padding: '5px'}}>₹ {(parseFloat(gst) + parseFloat(gst) ).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Discount</td>
                                            <td style={{padding: '5px'}}>₹ {parseFloat(orderData?.discount + orderData?.schemeValue).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Grand Total</td>
                                            <td style={{padding: '5px'}}>₹ {parseFloat( parseFloat(total) + parseFloat(gst) + parseFloat(gst) ).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <th style={{padding: '5px'}}>Round Total</th>
                                            <th style={{padding: '5px'}}>₹ {parseFloat(Math.round(parseFloat( parseFloat(total) + parseFloat(gst) + parseFloat(gst) ))).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            <th style={{padding: '5px'}}>Incentive</th>
                                            <th style={{padding: '5px'}}>₹ {Number(totalIncentive).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Zone</td>
                                            <td style={{padding: '5px'}}>{orderData?.zoneData?.zone}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Route</td>
                                            <td style={{padding: '5px'}}>{orderData?.dealerData?.routes}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Place</td>
                                            <td style={{padding: '5px'}}>{orderData?.dealerData?.locations}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>Vehicle No</td>
                                            <td style={{padding: '5px'}}>{orderData?.vNum}</td>
                                        </tr>
                                        <tr>
                                            <td style={{padding: '5px'}}>E-Way Bill</td>
                                            <td style={{padding: '5px'}}>{orderData?.eWayNum}</td>
                                        </tr>
                                    </table>
                                </div>


                                <div class="col-lg-4 mt-2" align="center" >
                                {orderData?.deleted === 'no' ?
                                    <div style={{height: '100%', borderRadius: '20px', alignContent: 'center', boxShadow: '0px 0px 10px 0px #cacacaff'}}>
                                        {userType === 'admin1' || userType === 'account' ?
                                            orderData?.edit === 'no' ? 
                                                <button class="btn btn-success mt-2" onClick={approve}><i class="fa fa-handshake-o"></i> Approve Edit</button>  
                                            :
                                                <button class="btn btn-primary mt-2" onClick={()=> {setEdit(!edit)}}><i class="fa fa-edit"></i> Edit Items</button>
                                        : orderData?.edit === 'yes' ?
                                            <button class="btn btn-primary mt-2" onClick={()=> {setEdit(!edit)}}><i class="fa fa-edit"></i> Edit Items</button>  
                                            :
                                            orderData?.eReason?.length > 0 && orderData?.edit === 'no' && orderData?.edited === 'no' ?
                                             <p className="text-warning">Edit request submitted!</p>
                                            :
                                            <button class="btn btn-danger mt-2" onClick={() => setInvEdit(true)}><i class="fa fa-commenting-o"></i> Edit Request</button> 
                                        }

                                        {/* <button class="btn btn-danger mt-2"><i class="fa fa-trash"></i></button> <br /> */}
                                        <br /><button class={`btn ${orderData?.paymentStatus === 'paid' ? 'btn-success' : 'btn-warning'} mt-2`} onClick={changeStatus}><i class="fa fa-inr"></i> {orderData?.paymentStatus}</button> <br />
                                        <button class="btn btn-success mt-2" onClick={manageInvoice}>Manage Invoice</button><br />
                                        <button class="btn btn-success m-2" onClick={()=>setEwbPop(true)}>E Way Bill</button> 
                                        <button class="btn btn-warning m-2" disabled={orderData?.dealerData?.gst?.length < 8 || orderData?.eInvNo?.length > 8} onClick={()=>eInvData()}>E-Invoice</button><br />
                                        {einvError && <p className='text-danger mt-2 mb-2'>{einvError}</p>}
                                        <button class="btn btn-danger mt-2" onClick={()=>setInvCancelPop(true)}>Invoice Cancel</button>
                                        {orderData?.notes?.length > 0 &&
                                            <div class="mt-4" style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                                <p>Notes</p>
                                                <small>{orderData?.notes}</small>
                                            </div>
                                        }
                                        {orderData?.eReason?.length > 0 &&
                                            <div class="mt-4" style={{border: '1px solid #333', borderRadius: '10px', padding: '10px 15px'}}>
                                                <p>Edit Reason</p>
                                                <small>{orderData?.eReason}</small>
                                            </div>
                                        }
                                    </div>

                                    : 
                                    <div style={{height: '100%', borderRadius: '20px', alignContent: 'center', boxShadow: '0px 0px 10px 0px #cacacaff'}}>
                                        <h5 className="text-danger text-bold mb-4">Invoice Cancelled</h5>
                                        <small className='mt-4'>{orderData?.reason}</small><br />
                                        <button class="btn btn-danger mt-2" onClick={cancelInvoice}>Cancel E-Invoice</button>
                                    </div>
                                    
                                    }
                               
                                    
                                </div>

                            </div>
                        </div>

                        {!edit ?


                        <div class="col-lg-12 mt-2">
                            <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Order Items</p>
				            </div>
				            <div class="box-body">
					            <div class="table-responsive">
                                <table className="table-sm table-bordered" width="100%">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowspan="2" width="3%">S.No</th>
                                            <th rowspan="2">PARTICULARS</th>
                                            {/* <th rowspan="2" width="4%">UNIT</th> */}
                                            <th rowspan="2" width="6%">CRATES</th>
                                            <th rowspan="2" width="6%">QTY</th>
                                            <th rowspan="2" width="6%">LTR</th>
                                            <th rowspan="2" width="6%">RATE/QTY</th>
                                            <th rowspan="2" width="8%">AMOUNT</th>
                                            {orderData?.dealerData?.gstType === 'SGST' ? 
                                                <>
                                                    <th colspan="2" width="8%">CGST</th>   
                                                    <th colspan="2" width="8%">SGST</th>
                                                </>
                                            :
                                                <th colspan="2" width="8%">IGST</th>  
                                            }
                                            <th rowspan="2" width="8%">Discount Type</th>
                                            <th rowspan="2" width="8%">Discount Value</th>
                                            <th rowspan="2" width="8%">Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                            {orderData?.dealerData?.gstType === 'SGST' && 
                                            <>
                                                <th>Rate(%) </th>
                                                <th>Value </th>
                                            </>
                                            }
                                          <th>Rate(%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderData && orderData?.orderData?.map((data, index) => {
                                          
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);
                                            const disCrates = getDiscountCrates(data.itemId);
                                            const rate = parseFloat(productPrice.toFixed(2)* ((parseFloat(data.qty)+ parseFloat(disCrates))* parseFloat(data.itemGrade))).toFixed(2);
                                            const gstRate = rate * (parseFloat(data.itemGst)/100);
                                            const gstRate2 = parseFloat(gstRate / 2).toFixed(2);
                                            const discount = getNewDiscounts(data.itemId);
                                            const disc = getDisc(data.itemId);
                                            

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                {/* <td>{data.itemUnit}</td> */}
                                                <td>{(parseFloat(data.qty) + parseFloat(disCrates)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight)/1000).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice).toFixed(2)}</td>
                                                <td>{rate}</td>
                                                {orderData?.dealerData?.gstType === 'SGST' ?
                                                    <>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat(gstRate /2).toFixed(2)}</td>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat(gstRate /2).toFixed(2)}</td>
                                                    </>
                                                :
                                                    <>
                                                        <td>{parseFloat(data.itemGst).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                }
                                                <td>{disc}</td>
                                                <td class="text-end">{parseFloat(discount).toFixed(2)}</td>
                                                <td class="text-end">{(parseFloat(rate) + parseFloat(gstRate2) + parseFloat(gstRate2)).toFixed(2)}</td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        <tr>
                                            
                                            <th colspan="2">TOTAL</th>
                                           
                                            <th>{parseFloat(crates).toFixed(2)}</th>
                                            <th>{parseFloat(qty).toFixed(2)}</th>
                                            <th>{parseFloat(weight).toFixed(2)}</th>
                                            <th></th>
                                            <th>{parseFloat(total).toFixed(2)}</th>
                                            {orderData?.dealerData?.gstType === 'SGST' ?
                                                <>
                                                    <th></th>
                                                    <th>{parseFloat(gst).toFixed(2)}</th>
                                                    <td></td>
                                                    <th>{parseFloat(gst).toFixed(2)}</th>
                                                </>
                                                :
                                                <>
                                                    <td></td>
                                                    <th>{parseFloat(gst * 2).toFixed(2)}</th>
                                                </>
                                            }
                                            <td></td>
                                            <th class="text-end">{parseFloat(orderData?.discount).toFixed(2)}</th>
                                            <th class="text-end">{parseFloat( parseFloat(total) + parseFloat(gst) + parseFloat(gst) - parseFloat(orderData?.discount)).toFixed(2)}</th>

   
                                        </tr>
							
						                </tbody>	
					                </table>
					            </div>              
				            </div>  
                        </div>
                        :
                        addSection ? 

                        <div class="col-lg-12 mt-2">
                            <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Add Items Items</p>
				            </div>
				            <div class="box-body">
					            <div class="row">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <div class="col-md-8">
									            <div class="form-group">
                                                    <label class="form-label">Select Product</label>
                                                    <select className="form-select" name="product" valu={selectedProduct} onChange={(e)=> setProduct(e.target.value)} required >
                                                        <option value="" hidden>Select Product</option>
                                                        {productData?.map((product, index) => 
                                                            <option value={product.id}>{product.productName}</option>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="col-md-4 mt-2" align="center">
											    <div class="input-group" >
												    <button class={`btn btn-sm ${inputType === 'crates' ? 'btn-primary' : 'btn-secondary'} mt-4`} onClick={()=> setinputType('crates')}>Crates</button>
												    <button class={`btn btn-sm ${inputType === 'ltr' ? 'btn-primary' : 'btn-secondary'} mt-4`} onClick={()=> setinputType('ltr')}>Litre</button>
											    </div>
										    </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label class="form-label">{inputType === 'crates' ? 'Crates' : 'Litre'}</label>
                                                    <div class="input-group">
                                                        <button type="button" class="btn btn-info" style={{padding: '5px 25px'}} onClick={()=> {changeNewQtyBtn('minus')}}>-</button>
                                                        <input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="phone" value={newQty} onChange={changeNewQty} required />
                                                        <button type="button" class="btn btn-info" style={{padding: '5px 25px'}} onClick={()=> {changeNewQtyBtn('plus')}}>+</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-4" align="right">
                                                <button type="button" class="btn btn-success mt-2" style={{padding: '5px 25px'}} onClick={addToExt}>Add</button>
                                            </div>
                                            <div class="col-md-3 mt-4" align="right">
                                                <button type="button" class="btn btn-danger mt-2" style={{padding: '5px 25px'}} onClick={()=> {setAddSection(!addSection)}}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        :
                        <div class="col-lg-12 mt-2" ref={bottomRef}>
                            <div class="box-header with-border">
				                <p class="mb-0 box-subtitle">Edit Order Items</p>
				            </div>
				            <div class="box-body" align="right">
					            <div class="table-responsive">
                                <table className="table-sm table-bordered" width="100%">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th width="4%">S.No</th>
                                            <th>PARTICULARS</th>
                                            <th width="15%">CRATES</th>
                                            <th width="30%">DISCOUNT</th>
                                            <th width="8%">AMOUNT</th>
                                            <th width="5%">DISCOUNT</th>
                                            <th width="8%">TOTAL</th>
                                            <th width="8%">REMOVE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderData?.orderData?.map((data, index) => {

                                            const discount = getNewDiscounts(data.itemId);
                                            const disCrates = getDiscountCrates(data.itemId);
                                            const qty = parseFloat(parseFloat(Object.values(inputData).find(item => item.product === data.itemId)?.qty) + parseFloat(disCrates)).toFixed(2);
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);

                                            const rate = parseFloat(productPrice.toFixed(2)* ((parseFloat(qty)+ parseFloat(disCrates))* parseFloat(data.itemGrade))).toFixed(2);
                                            const gstRate = rate * (parseFloat(data.itemGst)/100);

                                            const Total = parseFloat(parseFloat(rate) + parseFloat(gstRate));

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td>
                                                    <div class="input-group">
													    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 15px'}} onClick={()=> {changeQtyBtn(data.itemId, 'minus')}}>-</button>
									            	    <input type="number" class="form-control" style={{textAlign: 'center'}} value={Object.values(inputData).find(item => item.product === data.itemId)?.qty || ''} onChange={(e)=> changeQty(data.itemId, e.target.value)} />
									        		    <button type="button" class="btn btn-info btn-sm" style={{padding: '5px 15px'}} onClick={()=> {changeQtyBtn(data.itemId, 'plus')}}>+</button>
												    </div>
                                                </td>
                                                <td>
                                                    <div class="input-group">
                                                        <select className="form-select" name="type" value={newDiscountData.find(entry => entry.item === data.itemId)?.type || ''} onChange={(e)=> handleDiscountTypeChange(e.target.value, data.itemId)}>
                                                            <option value="" hidden>Select Options</option>
                                                            <option value="liters">Littres</option>
                                                            <option value="grade">Crates</option>
                                                            <option value="packet">Packets</option>
                                                        </select>
                                                        <select className="form-select" name="discount" value={newDiscountData.find(entry => entry.item === data.itemId)?.discount || ''} onChange={(e)=> handleDiscountDiscountChange(e.target.value, data.itemId)}>
                                                            <option value="" hidden>Select Options</option>
                                                            <option value="amount">Amount</option>
                                                            <option value="packet">Packet</option>
                                                        </select>
                                                        <input type="parseFloat" class="form-control" style={{textAlign: 'center'}} name="value" value={newDiscountData.find(entry => entry.item === data.itemId)?.value || ''} onChange={(e)=> handleDiscountValueChange(e.target.value, data.itemId)} />
                                                    </div>
                                                </td>
                                                <td>{parseFloat(Total).toFixed(2)}</td>
                                                <td>{parseFloat(discount).toFixed(2)}</td>
                                                <td>{(parseFloat(Total) - parseFloat(discount)).toFixed(2)}</td>
                                                <td><button class="btn btn-danger" onClick={()=> {removeItem(data.id)}}><i class="fa fa-trash"></i></button></td>
                                            </tr>
                                        )})}
                                            <tr>
                                                <th colspan="4">Total</th>
                                                <th>{parseFloat(newTotal + newGst).toFixed(2)}</th>
                                                <th>{parseFloat(newDiscount).toFixed(2)}</th>
                                                <th>{(parseFloat(newTotal + newGst) - parseFloat(newDiscount)).toFixed(2)}</th>
                                            </tr>
                                    </tbody>
                                </table>

                                <button class="btn - btn-danger me-2 mt-4" onClick={()=> {setEdit(!edit)}}>Cancel</button>
                                <button class="btn - btn-success me-2 mt-4" onClick={()=> {setAddSection(!addSection)}}>Add Items</button>
                                <button class="btn - btn-primary mt-4" onClick={placeOrder}>Update Invoive</button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-12 mt-4" align="right">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="true">
                                 Download
                            </button>

                            <ul class="dropdown-menu p-3 text-center" style={{minWidth: '250px'}} aria-labelledby="dropdownMenuButton">
                               {sectionIds.map(({ id, label }) => (
                                <div class="form-check" key={id} >
                                    <button class={`btn btn-sm w-100 ${selectedSections.includes(id) ? 'btn-primary' : 'btn-secondary'}`} onClick={(e) => {e.stopPropagation(); handleCheckboxChange(id); }} >{label}</button>
                                </div>
                                ))}
                                <hr />
                                <button class="btn btn-success mt-2" onClick={()=>{downloadCombinedPDF('download')}}> <i class="fa fa-download"></i> Download Selected</button>
                            </ul>

                        
                            {/* <button class="btn btn-warning m-2" onClick={()=>{downloadCombinedPDF('download')}}><i class="fa fa-download"></i> Download Invoice</button> */}
                            <button class="btn btn-success m-2" onClick={()=>{downloadCombinedPDF('whatsapp')}}><i class="fa fa-whatsapp"></i> Send Invoice</button>
                            <button class="btn btn-info m-2" onClick={()=>{downloadCombinedPDF('view')}}><i class="fa fa-file"></i> View Invoice</button>
                            <button class="btn btn-primary m-2" onClick={()=>{downloadCombinedPDF('print')}}><i class="fa fa-print"></i> Print Invoice</button>

                          {/* <InvoiceDocument invoice={orderData}  /> */}
                            <Invoice 
                                getData={orderData} 
                                incentive={recInc}
                            />
                        </div>
                        
                    </div>
                    <div style={{float: 'right'}}>
                        <a class="btn btn-secondary mt-4" href="/all-invoice"> <i class="fa fa-arrow-left"></i> Back to Invoices</a>
                    </div>
                </div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;